<template>
	<div class="grid grid-cols-2 gap-1">
		<div class="flex flex-wrap content-center">
			<p class="text-sm mb-0" style="color:#63b3ed;">
				{{ options.label }}
			</p>
		</div>
		<div class="flex flex-wrap content-center">
			<p
				class="mb-0 text-5xl sm:text-2xl md:text-5xl lg:text-5xl xl:text-5xl font-semibold"
				:style="'color:' + color() + ';'"
			>
				{{ value()
				}}<span style="color:#bdbdbd;">{{ options.unit }}</span>
			</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'MTextHorizontal',
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			}
		},
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	methods: {
		color() {
			if ('color' in this.options) {
				return this.options.color
			} else return '#757575'
		},
		value() {
			if (this.data.length > 0) {
				return this.data[0][this.options.value]
			}
			return 0
		}
	}
}
</script>
